function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIceRiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M489.403 466.925H22.597c-8.338 0-15.097-6.759-15.097-15.097v-259.98h497v259.98c0 8.338-6.759 15.097-15.097 15.097z",
    style: {},
    fill: "#6c7fd8",
    "data-original": "#6c7fd8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.47 191.848v259.98c0 8.338-6.759 15.097-15.098 15.097h30.03c8.338 0 15.097-6.759 15.097-15.097v-259.98H474.47z",
    style: {},
    fill: "#4f66d0",
    "data-original": "#4f66d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 191.848v-39.709c0-8.229 7.519-14.407 15.592-12.812l110.632 21.862 148.122-23.458a42.309 42.309 0 0 1 18.496 1.181l80.601 23.575 107.785-22.891c8.124-1.725 15.773 4.47 15.773 12.775v39.477H7.5z",
    style: {},
    fill: "#dff6fd",
    "data-original": "#dff6fd",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.5 152.37v39.48h-30.03v-33.48c0-7.24-5.81-12.87-12.68-13.05l26.94-5.72c8.12-1.73 15.77 4.47 15.77 12.77z",
    style: {},
    fill: "#c8effe",
    "data-original": "#c8effe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 225.948h68.478l-19.403 21.343a22.297 22.297 0 0 1-16.5 7.299H7.5v-28.642z",
    style: {},
    fill: "#dff6fd",
    "data-original": "#dff6fd",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.563 220.489h-93.238l17.593-22.968a14.476 14.476 0 0 1 11.492-5.674h49.676c7.995 0 14.476 6.481 14.476 14.476v14.166z",
    style: {},
    fill: "#c8effe",
    "data-original": "#c8effe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.827 280.132H105.838l17.008-22.205a16.424 16.424 0 0 1 13.039-6.437h81.932c5.117 0 9.942 2.385 13.049 6.451l16.961 22.191zM468.428 254.59h-110.91v-12.448c0-8.943 7.25-16.194 16.194-16.194h55.749c3.908 0 7.684 1.413 10.632 3.979l28.335 24.663zM339.479 284.111l-16.736 12.702a16.08 16.08 0 0 0-5.41 18.249l4.734 13.163a24.69 24.69 0 0 0 14.09 14.578l65.995 26.306a24.688 24.688 0 0 0 21.03-1.296l39.004-21.431a12.039 12.039 0 0 0 6.242-10.552v-29.21a12.039 12.039 0 0 0-10.505-11.941l-106.675-13.708c-4.183-.538-8.41.59-11.769 3.14zM430.036 466.925v-46.659a20.553 20.553 0 0 1 9.801-17.516l64.663-39.689v88.766c0 8.338-6.759 15.097-15.097 15.097h-59.367z",
    style: {},
    fill: "#dff6fd",
    "data-original": "#dff6fd",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.47 381.494v70.334c0 8.338-6.759 15.097-15.098 15.097h30.03c8.338 0 15.097-6.759 15.097-15.097v-88.766l-30.029 18.432z",
    style: {},
    fill: "#c8effe",
    "data-original": "#c8effe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.483 466.925-47.719-76.907a14.579 14.579 0 0 1 2.779-18.65l10.343-9.065a24.147 24.147 0 0 1 17.405-5.942l54.602 3.368a25.03 25.03 0 0 1 8.865 2.218l81.114 37.066a20.55 20.55 0 0 1 12.01 18.693v49.22H251.483zM7.5 411.337l89.607-30.662a19.475 19.475 0 0 1 16.572 1.877l38.773 24.056a19.473 19.473 0 0 1 8.982 13.594l7.171 46.723H22.597c-8.338 0-15.097-6.759-15.097-15.097v-40.491zM7.5 377.687l135.738-47.893c7.127-2.514 6.148-12.887-1.323-14.025L52.03 302.082a34.933 34.933 0 0 0-15.244 1.059L7.5 311.873v65.814z",
    style: {},
    fill: "#dff6fd",
    "data-original": "#dff6fd",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.56 206.32v14.17h-30.05v-14.17c0-7.99-6.48-14.47-14.48-14.47h30.06c7.99 0 14.47 6.48 14.47 14.47z",
    style: {},
    fill: "#99e6fc",
    "data-original": "#99e6fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.83 280.13h-30.06l-16.96-22.19a16.441 16.441 0 0 0-13.05-6.45h30.06c5.11 0 9.94 2.39 13.05 6.45l16.96 22.19zM468.43 254.59h-30.06l-28.33-24.66a16.188 16.188 0 0 0-10.63-3.98h30.05c3.91 0 7.68 1.41 10.63 3.98l28.34 24.66zM390.88 417.71v49.22h-30.05v-49.22c0-8.05-4.69-15.35-12.01-18.7l-81.12-39.06c-1.99-.91-4.09-1.56-6.25-1.91l27.44 1.69c3.07.19 6.07.94 8.87 2.22l81.11 37.06a20.558 20.558 0 0 1 12.01 18.7zM168.61 466.93h-30.06l-7.17-46.73a19.455 19.455 0 0 0-8.98-13.59l-35.92-22.29 10.63-3.64c5.52-1.9 11.61-1.21 16.57 1.87l38.77 24.06c4.84 3 8.12 7.97 8.98 13.59l7.18 46.73zM143.24 329.79 7.5 377.69v-10.6l105.68-37.3c7.13-2.51 6.15-12.88-1.32-14.02l-77.73-11.84 2.66-.79a35.062 35.062 0 0 1 15.24-1.06l89.89 13.69c7.47 1.14 8.45 11.51 1.32 14.02zM457.923 294.679l-25.303-3.251a12.03 12.03 0 0 1 5.754 10.257v34.146c0 4.392-2.392 8.436-6.242 10.551l-36.577 20.097 6.597 2.63a24.688 24.688 0 0 0 21.03-1.296l39.004-21.431a12.038 12.038 0 0 0 6.242-10.551v-29.21a12.038 12.038 0 0 0-10.505-11.942z",
    style: {},
    fill: "#c8effe",
    "data-original": "#c8effe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.5 226.874v224.954c0 8.338-6.759 15.097-15.097 15.097H22.597c-8.338 0-15.097-6.759-15.097-15.097v-259.98h497",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 191.848v-39.709c0-8.229 7.519-14.407 15.592-12.812l110.632 21.862 148.122-23.458a42.309 42.309 0 0 1 18.496 1.181l80.601 23.575 107.785-22.891c8.124-1.725 15.773 4.47 15.773 12.775v39.477H7.5zM69.925 148.582V45.075M49.939 92.731l19.986 16.911M101.695 84.02l-31.77 39.458M464.321 144.779V72.183M444.335 88.635l19.986 16.91M483.955 94.997l-19.634 24.384M203.487 150.141V45.075M183.5 92.731l19.987 16.911M203.487 123.478l31.77-39.458V65.388",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.878 157.191V76.128l-18.71-26.594M426.734 50.534l-20.856 25.594M366.5 84.02l39.378 39.458M296.579 273.734l12.797-7.923M7.5 225.948h68.478l-19.403 21.343a22.297 22.297 0 0 1-16.5 7.299H7.5v-28.642zM282.563 220.489h-93.238l17.593-22.968a14.476 14.476 0 0 1 11.492-5.674h49.676c7.995 0 14.476 6.481 14.476 14.476v14.166zM141.885 280.132h-36.047l17.008-22.205a16.424 16.424 0 0 1 13.039-6.437h81.932c5.117 0 9.942 2.385 13.049 6.451l16.961 22.191h-70.866M468.428 254.59h-110.91v-12.448c0-8.943 7.25-16.194 16.194-16.194h55.749c3.908 0 7.684 1.413 10.632 3.979l28.335 24.663zM339.479 284.111l-16.736 12.702a16.08 16.08 0 0 0-5.41 18.249l4.734 13.163a24.69 24.69 0 0 0 14.09 14.578l65.995 26.306a24.688 24.688 0 0 0 21.03-1.296l39.004-21.431a12.039 12.039 0 0 0 6.242-10.552v-29.21a12.039 12.039 0 0 0-10.505-11.941l-106.675-13.708c-4.183-.538-8.41.59-11.769 3.14zM430.036 466.925v-46.659a20.553 20.553 0 0 1 9.801-17.516l64.663-39.689v88.766c0 8.338-6.759 15.097-15.097 15.097h-59.367zM251.483 466.925l-47.719-76.907a14.579 14.579 0 0 1 2.779-18.65l10.343-9.065a24.147 24.147 0 0 1 17.405-5.942l54.602 3.368a25.03 25.03 0 0 1 8.865 2.218l81.114 37.066a20.55 20.55 0 0 1 12.01 18.693v49.22H251.483zM7.5 411.337l89.607-30.662a19.475 19.475 0 0 1 16.572 1.877l38.773 24.056a19.473 19.473 0 0 1 8.982 13.594l7.171 46.723H22.597c-8.338 0-15.097-6.759-15.097-15.097v-40.491zM7.5 377.687l135.738-47.893c7.127-2.514 6.148-12.887-1.323-14.025L52.03 302.082a34.933 34.933 0 0 0-15.244 1.059L7.5 311.873v65.814zM219.795 323.451H256",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceRiver);
export default __webpack_public_path__ + "static/media/iceRiver.dd69046bc7cd9459bad02bd824eaf903.svg";
export { ForwardRef as ReactComponent };